import styled from "styled-components";

export const Container = styled.div`
  margin: 20px auto;
  padding: 20px;
`;

export const Title = styled.h2`
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin: 40px 0px;
`;

export const Field = styled.div<{ fullWidth?: boolean }>`
  display: flex;
  flex-direction: column;
  ${({ fullWidth }) => fullWidth && "grid-column: span 2;"}
`;

export const Label = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: #555;
  margin-bottom: 4px;
`;

export const Value = styled.div`
  font-size: 14px;
  color: #222;
  background: #fff;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid #eee;
`;

export const Input = styled.input`
  font-size: 14px;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid #eee;
  background: #fff;
`;

export const ButtonConfirm = styled.button`
  width: 100%;
  padding: 10px 16px;
  border: none;
  border-radius: 6px;
  background: #007bff;
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  height: 50px;

  &:hover {
    background: #0056b3;
  }
`;

export const CardChargeBack = styled.div`
  padding: 10px 16px;
  border: solid 1px #ccc;
  border-radius: 15px;
  background-color: #fff;

  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 300px;
`;

export const ChargeBackTitle = styled.div`
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  width: 100%;
`;
